import { signOut } from "aws-amplify/auth";
import { useTranslation } from "react-i18next";

export const useAuthLogout = () => {
  const { t } = useTranslation();

  const logout = async () => {
    if (confirm(t("auth:logout"))) {
      await signOut();
    }
  };

  return logout;
};
